// extracted by css-extract-rspack-plugin
export default {"root":"root-2PJHr","button":"button-1TVkv","actionList":"actionList-3s02D","secondary":"secondary-137Ik","small":"small-2g7ZL","medium":"medium-3wr4I","passive":"passive-3k_57"};